import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServiceEditor.html?raw';
import "../EvBookingEditorTypes";
import '../../../moreCore/UI/DateTimeInput/DateTimeInput';
import '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import SelectEntityDialog from '../../../moreCore/UI/SelectEntityDialog/SelectEntityDialog';

class ServiceEditor extends compose(_WidgetBaseSP) {
    templateString: any = template;
    searchInput: MdsLax<InstanceType<typeof HintBox>>;
    taskTypeSelect: MdsLax<InstanceType<typeof SearchSelect>>;

    roomId: string = null;

    private _loadedSEDConfig: any = null;
    private mode: string = "selectEvServices";

    _onChangeInput(): void {
        let value = this.searchInput.getValue();

        if (value != null) {
            this.emit("added", value, [EvBookingEditor_ListNames.EvService]);
            this.searchInput.setValue(null);
        }
    }
   
    setRoomId(value: string): void {

        this.roomId = value;

        this.searchInput.addRequestProperty("roomID", this.roomId);

        this.searchInput.addAdditionalRequestParameter("roomID", this.roomId);

    }

    private _onClick_AddService(evt: MouseEvent): void {
        this.loadSelectEntityDlgConfig();
    }

    loadSelectEntityDlgConfig(): void {
        this.searchInput.closeList();

        if (this._loadedSEDConfig) {
            this._onLoadSEDConfig(this._loadedSEDConfig);
            return;
        }

        this.StandbyStart();

        let data = {
            "mode": this.mode,
        };

        let url = window.appRoot + "EvBookingEditor/GetSEDconfig";

        this.RequestManager.post(
            url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadSEDConfig),
            lang.hitch(this, this._onDeleteProjectError),
            false // sync
        );
    }

    private _onDeleteProjectError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }

    private _onLoadSEDConfig(response: { config: any, services: Array<any> }): void {

        this._loadedSEDConfig = response;

        this.StandbyStop();
        this.emit("openedSED");

        let dlg = new SelectEntityDialog();
        dlg.setConfiguration(response.config ? response.config : response as any, lang.hitch(this, this._onSEDresponse));

        dlg.addGlobalRequestProperty("mode", this.mode);
        dlg.addGlobalRequestProperty("roomId", this.roomId);

        dlg.show();
    }

    private _onSEDresponse(results: Array<string>, items: Array<any>): void {
        console.log("_onSEDresponse ServiceEditor", results, items);

        if (!items?.length) return;

        this.searchInput.setValue(null, true);

        items.forEach(item => {

            let sourceTree = item.sourceTree;

            switch (sourceTree) {
                case "singleService":
                case "servicesInRoom":
                case "servicesNotInRoom":
                case "servicesByCategory":

                    this.emit("added", item.entry.data, [EvBookingEditor_ListNames.EvService]);
                    break;
                case "servicePackages":

                    item.entry.data.service.forEach(service => {

                        this.emit("added", service, [EvBookingEditor_ListNames.EvService]);
                    });

                    break;
            }
        });
    }


    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.domNode.addEventListener('click', function (evt) {

            evt.stopPropagation();

        });

        this.searchInput.addInlineButton(lang.hitch(this, this.loadSelectEntityDlgConfig));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServiceEditor);